import React, { type ReactNode, useContext } from 'react';

import { ThemeContext } from 'styled-components';

import { Selected } from './components';

import { ActionToastWrapper } from './styles';

export interface ActionToastProps {
    children: ReactNode;
    wide?: boolean;
}

export function ActionToast({ children, wide = false }: ActionToastProps) {
    const theme = useContext(ThemeContext);

    return (
        <ActionToastWrapper
            $wide={wide}
            initial={{ y: 160, x: '-50%' }}
            animate={{ y: 0 }}
            exit={{ y: 160 }}
            transition={{
                duration: theme.transitions.speeds.normal,
                ease: theme.transitions.eases.cubic,
            }}
        >
            {children}
        </ActionToastWrapper>
    );
}

ActionToast.Selected = Selected;
